import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";

const root = ReactDOM.createRoot(document.getElementById("root"));
// axios.defaults.baseURL = "http://10.129.2.234:5090";
// axios.defaults.baseURL = "http://192.168.2.118:5020";
// axios.defaults.baseURL = "http://10.129.2.234:5090";
// axios.defaults.baseURL = "http://192.168.2.145:3000";


axios.defaults.baseURL = "https://apiv3.tagsmart.tagid.co.in/register-api";
root.render(
  // <ConfigProvider
  //   theme={{
  //     algorithm: theme.compactAlgorithm,
  //   }}
  // >
  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </ConfigProvider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
